
export const showUnit = (unitCode, unitNo) => {

    let text = ""
    if(unitCode){
        text += unitCode
    }

    if(unitNo){
        text += ` (${unitNo})`
    }

    return text

}